module.exports = __webpack_public_path__ + "prod/1.2.3/img/change.8f8564e5.png";